<template>
  <div class="basic_con">
    <el-row :gutter="20">
      <el-col :span="12">
        <Frame title="基本信息">
          <template slot="contentSlot">
            <div class="content_con">
              <el-image
                class="border_line"
                src="/img/factoring/border_line.svg"
              ></el-image>
              <div class="label_wrapper">
                <div class="left">客户类别:</div>
                <div class="right">
                  {{
                    dataInfo.custCategory == 1
                      ? "个人客户"
                      : dataInfo.custCategory == 2
                      ? "机构客户"
                      : ""
                  }}
                </div>
              </div>
              <div class="label_wrapper">
                <div class="left">客户类型:</div>
                <div class="right">{{ dataSource.custTypeStr }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">{{dataInfo.custCategory == 2 ? "统一社会信用代码" : "身份证号码"}}:</div>
                <div class="right">{{ dataInfo.unifiedSocialCreditCode }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">注册资本(万元):</div>
                <div class="right">{{ dataInfo.registeredCapital }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">客户性质:</div>
                <div class="right">{{ dataSource.custAttributeStr }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">所属行业:</div>
                <div class="right">
                  {{ dataInfo.industryStr }}
                </div>
              </div>
              <div class="label_wrapper">
                <div class="left">企业类型:</div>
                <div class="right">{{ dataSource.enterpriseTypeStr }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">企业规模:</div>
                <div class="right">{{ dataSource.enterpriseScaleStr }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">成立时间:</div>
                <div class="right">{{ dataInfo.fundingTime }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">联系电话:</div>
                <div class="right">{{ dataInfo.contactNumber }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">注册地址:</div>
                <div class="right">{{ dataInfo.registeredAddress }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">办公地址:</div>
                <div class="right">{{ dataInfo.officeAddress }}</div>
              </div>
            </div>
          </template>
        </Frame>
      </el-col>
      <!-- <el-image class="border_line" src="/img/factoring/border_line.svg"></el-image>   -->
      <el-col :span="12">
        <Frame title="开票信息">
          <template slot="contentSlot">
            <div class="content_con">
              <div class="label_wrapper">
                <div class="left">客户名称:</div>
                <div class="right">{{ dataInfo.custName }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">纳税人识别号:</div>
                <div class="right">{{ dataInfo.unifiedSocialCreditCode }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">联系电话:</div>
                <div class="right">{{ dataInfo.taxpayerPhone }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">开户行:</div>
                <div class="right">{{ dataInfo.taxpayerBankName }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">银行账号:</div>
                <div class="right">{{ dataInfo.taxpayerBankno }}</div>
              </div>
              <div class="label_wrapper">
                <div class="left">注册地址:</div>
                <div class="right">
                  {{ dataInfo.registeredAddress }}
                </div>
              </div>
            </div>
          </template>
        </Frame>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import * as api from "@/api/factoring/factoringCustomer";
import { regionData, CodeToText } from "element-china-area-data";
import util from "@/mixins/util";
export default {
  name: "basics",
  mixins: [util],
  components: {
    Frame,
  },
  data() {
    return {
      dataSource: {},
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    dataInfo: {
      immediate: true,
      handler(newName, oldName) {
        let dataInfo=JSON.parse(JSON.stringify(newName))
        this.dictionaryMapInfo(dataInfo);
      },
    },
  },
  mounted() {},

  methods: {
    async dictionaryMapInfo(dataInfo) {
      let dataList = [
        { code: "cust_type_rzzl", name: "custType" },
        { code: "bl_cust_attribute", name: "custAttribute" },
        { code: "enterprise_type", name: "enterpriseType" },
        { code: "enterprise_scale", name: "enterpriseScale" },
      ];
      let dataSource = await this.dictionaryMap(dataList, dataInfo);

      this.$nextTick(() => {
        
        this.dataSource = dataSource;
      });

      // let codeList = dataList.map((item) => {
      //   return item.code;
      // });
      // let res = await api.dictionaries(`code=${codeList.join(",")}`);
      // if (res.data.code == 200) {
      //   let dataSource = {};
      //   dataList.map((item) => {
      //     let num = this.dataInfo[item.name].indexOf(",");
      //     dataSource[item.name + "Name"] = "";
      //     if (num > -1) {
      //       this.dataInfo[item.name] = this.dataInfo[item.name]
      //         ? this.dataInfo[item.name].split(",")
      //         : [];
      //     }
      //     res.data.data[item.code].map((el) => {
      //       if (num > -1) {
      //         this.dataInfo[item.name].map((item_) => {
      //           if (parseFloat(el.dictKey) == parseFloat(item_)) {
      //             dataSource[item.name + "Name"] = dataSource[item.name + "Name"]
      //               ? dataSource[item.name + "Name"] + "," + el.dictValue
      //               : el.dictValue;
      //           }
      //         });
      //       } else {
      //         console.log(item.name)
      //         console.log(this.dataInfo[item.name])
      //         if (
      //           parseFloat(el.dictKey) == parseFloat(this.dataInfo[item.name])
      //         ) {
      //           dataSource[item.name + "Name"] = el.dictValue;
      //         }
      //       }
      //       // return parseFloat(el.dictKey) == parseFloat(this.dataInfo[item]);
      //     });
      //   });
      //   this.$nextTick(() => {
      //     this.dataSource = { ...this.dataSource,...dataSource };
      //     console.log(this.dataSource);
      //   });
      // }
    },
  },
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
}
.content_con {
  text-align: center;
  padding: 0 20px;
  position: relative;
}
.border_line {
  width: 2px;
  height: 527px;
  position: absolute;
  right: 0;
}
.label_wrapper {
  display: flex;
  align-items: center;
  height: 45px;
  line-height: 45px;
  .left {
    font-weight: 700;
    font-style: normal;
    color: #999999;
    text-align: right;
    line-height: 28px;
    width: 25%;
    min-width: 150px;
  }
  .right {
    margin-left: 10px;
    font-weight: 400;
    font-style: normal;
    text-align: left;
    line-height: 28px;
    color: #333333;
    flex: 1;
  }
}
</style>

